import React from 'react'
import { logSessionInfo } from '../../../services/logger';
import VirtualScreen from '../../Reader/VirtualScreen/VirtualScreen';
import { READY_MODULE_EVENTS } from '../constants';
import CheckWrapper from './CheckWrapper';
import RaiseHand from './PreCheckIllustrations/RaiseHand';
import StudentInstruction from './StudentInstruction';

class StudentPreCheckErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: '' };
    this.moveOn = this.moveOn.bind(this)
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true, error: error };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    console.error("StudentPreCheckErrorBoundary", error, errorInfo)
    logSessionInfo(`ready_StudentPreCheckErrorBoundary`, error)
    this.props.logEvent(READY_MODULE_EVENTS.HIT_ERROR_BOUNDARY)
  }

  moveOn(){
    this.props.continueToNextCheckWithError(this.state.error && this.state.error.toString()) 
    this.setState({
      hasError: false,
      error: ''
    })
  }

  render() {
    if (this.state.hasError) {
      // TODO: Figure out what is most appropriate for when there is
      // an uncaught exception in any of the checks.
      return <VirtualScreen invisible={false}>
        <CheckWrapper>
          <StudentInstruction>
            <h2>Oops, something is wrong.</h2>
            <RaiseHand />
            <p>You try to continue without the checks.</p>
            <button onClick={this.moveOn}>Continue</button>
          </StudentInstruction>
        </CheckWrapper>
      </VirtualScreen>;
    }

    return this.props.children;
  }
}

export default StudentPreCheckErrorBoundary